<template>
  <div>
    <el-table
      ref="excelTableRef"
      :class="type == 'dashboard' ? 'main_table' : 'main_d_table'"
      :data="excelTableData">
      <el-table-column
        prop="batch_no"
        label="批次" />
      <el-table-column
        prop="template_name"
        label="模板名称" />
      <el-table-column
        label="工具能力">
        <template slot-scope="scope">
          {{ scope.row.type == 'capture' ? '数据采集' : scope.row.type == 'product_template' ? '商品套图' : scope.row.type == 'artwork' ? 'ai生成' : '--' }}
        </template>
      </el-table-column>
      <el-table-column
        label="状态" width="90">
        <template slot-scope="scope">
          {{ scope.row.status == 0 ? '生成中' : scope.row.status == 1 ? '成功' : '失败' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间" />
      <el-table-column label="操作" width="90">
        <template slot-scope="scope">
          <el-button type="text" @click="downloadExcel(scope.row)" v-if="scope.row.status == 1">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="main_pagination"
      background
      @current-change="handleCurrentChange"
      layout="prev, pager, next"
      :page-size="excelForm.limit"
      :total="excelTableTotal">
    </el-pagination>
  </div>
</template>
<script>
import { templateGetExcelRecord } from "@/api/templateTask";
import FileSaver from "file-saver";
export default {
  name: "ExcelTableCom",
  // dashboard  我的工作台
  props: {
    type: {
      type: String,
      default: "export"
    }
  },
  data () {
    return {
      excelForm: {
        page: 1,
        limit: 8
      },
      excelTableData: [],
      excelTableTotal: 0,
      refreshTimer: null,
    }
  },
  created() {
    if(this.type == 'dashboard') {
      this.excelForm.limit = 10;
    }
    console.log('chuangjian');
    this.getExcelList()
  },
  beforeDestroy() {
    console.log('xiaohui');
    if(this.refreshTimer) {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = null;
    }
    
  },
  methods:{
    refreshTaskNum() {
      let isrefresh = this.excelTableData.some(item => item.status == 0)
      console.log('isrefresh', isrefresh, this.excelTableData)
      if(isrefresh) {
        this.refreshTimer = setTimeout(() => {
          this.getExcelList()
        }, 4000);
      }
    },
    downloadExcel(row) {
      FileSaver.saveAs(row.path, row.batch_no + '-' + row.template_name + '.xlsx');
    },
    handleCurrentChange(val) {
      this.excelForm.page = val
      this.getExcelList()
    },
    getExcelList() {
      templateGetExcelRecord(this.excelForm).then(res => {
        this.excelTableData = res.data.data
        this.excelTableTotal = res.data.total
        this.refreshTaskNum()
      })
    },
  }
}
</script>
<style lang="scss" scoped>
</style>